import * as Yup from "yup";

export const validationSchema = [
  Yup.object().shape({
    Equipment: Yup.object().shape({
      EquipmentID: Yup.string().required("Required"),      
    }),
    PrescriptionImage: Yup.string().trim(),
  }),
  Yup.object().shape({
    Medication: Yup.object().shape({
      MedicationID: Yup.string().trim().required("Required"),
      StartDate: Yup.date().required("Required"),
      EndDate: Yup.date().required("Required"),
    }),
    PrescriptionImage: Yup.string().trim(),
  }),
];
